import React, { useState, useEffect } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";

import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import { FormButton, FormInput, FormStatusSelect } from "../../components/form";
import { privateApi } from "../../api";

const FaqTypeEdit = () => {
      const { typeId } = useParams();

      const [title, setTitle] = useState("");
      const [status, setStatus] = useState("");
      const [loading, setLoading] = useState(false);

      const loadData = async () => {
            await privateApi
                  .get(`/dashboard/faq_types/${typeId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setTitle(response.data.type.title);
                              setStatus(response.data.type.status);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title,
                  status: status,
            };

            await privateApi
                  .post(`/dashboard/faq_types/${typeId}`, data)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleForm}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Edit Faq Type">
                                                <LinkButton
                                                      title="Back"
                                                      link="/dashboard/faqs/types"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Title"
                                                            classes={8}
                                                            required={true}
                                                            value={title}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            selected={status}
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Row>
                                                      <Col lg={12}>
                                                            <FormButton
                                                                  title="Update"
                                                                  loading={
                                                                        loading
                                                                  }
                                                            />
                                                      </Col>
                                                </Row>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default FaqTypeEdit;
